import React from "react";
import "./App.css";
import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import TopBar from "../src/app/components/TopBar";
import BackToTop from 'react-back-to-top';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { BottomBar } from "./app/components";
import ScrollToTop from "./app/components/RouteToTop";
import ReactGA from 'react-ga4';

//ReactGA.initialize(process.env.REACT_APP_GA_TRACKING);

const theme = createTheme({
  palette: {
    primary: {
      main: '#E45417',
      secondary: "#2a0d36"
    },
    secondary: {
      main: '#E45417'
    },
    white: {
      main: "#faf9f8"
    }
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App mt-5">
        <BrowserRouter>
          <TopBar />
          <div className="fullPage">
            <Router />
            <ScrollToTop />
            <BackToTop
              mainStyle={{
                "border-radius": 30,
                "background-color": "var(--secColor)"
              }}
              children={<KeyboardArrowUpIcon sx={{ color: "var(--appBg)" }} />}
              isPercent={false}
              offsetTop={0}
              step={50} />
          </div>
          {/* <BottomBar /> */}
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
